import { createFileRoute } from '@tanstack/react-router'
import { NnppAcceptanceReviewPage } from 'pages/nnpp/acceptance/NnppAcceptanceReviewPage'

export const Route = createFileRoute('/nnpp/acceptance-review/$testId')({
  component: NnppAcceptanceReviewRoute,
  staticData: {
    layout: { enableScrolling: true },
  },
})

function NnppAcceptanceReviewRoute() {
  const { testId } = Route.useParams()
  return <NnppAcceptanceReviewPage testId={testId} />
}
